import React from "react";

const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_maclear-holdings/artifacts/tofoqejc_1.png";

// Cape Maclear Holdings official coin logo
export const Logo = ({ size = 48, showWordmark = true, variant = "dark" }) => {
  const wordmarkColor = variant === "light" ? "#FCFCFA" : "#1A1D20";
  return (
    <div className="flex items-center gap-3" data-testid="site-logo">
      <img
        src={LOGO_SRC}
        alt="Cape Maclear Holdings"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        className="block shrink-0"
      />
      {showWordmark && (
        <div className="flex flex-col leading-tight">
          <span
            className="font-serif-display text-[15px] md:text-[17px] tracking-wider"
            style={{ color: wordmarkColor }}
          >
            CAPE MACLEAR
          </span>
          <span
            className="font-body text-[10px] md:text-[11px] tracking-[0.35em] uppercase"
            style={{ color: "#D4AF37" }}
          >
            Holdings
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
